import React from "react";
import PropTypes from "prop-types";
import ArrowLeft from "rialto-icons/ArrowLeft";

import Translate from "utils/translate";

import styles from "../Navbar/Navbar.css";

const { t } = new Translate("Navbar");

const BackButton = ({ onBack }) => (
  <div className={styles.back} onClick={onBack}>
    <div className={styles.text}>
      <ArrowLeft />
      <span>{t("back")}</span>
    </div>
    <div className={styles.divider} />
  </div>
);

BackButton.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default BackButton;
